export const SocialProofResourcesEn = {
    1: {
        proof: "800+",
        text: "partner stores",
    },
    2: {
        proof: "up to 60%",
        text: "cashback",
    },
    3: {
        proof: "1M+",
        text: "people already use goodie",
    },
    4: {
        proof: "110M PLN",
        text: "cashback awarded",
    },
};
